export enum HostMessage {
    NoMessage = 0,
    Resume = 1,
    StartingSoon = 2,
}
